// extracted by mini-css-extract-plugin
module.exports = {"pageBackground":"PageBackground_pageBackground__UyaVP"};